import { render } from "./uploadBraExcelModal.vue?vue&type=template&id=3325e440&ts=true"
import script from "./uploadBraExcelModal.vue?vue&type=script&lang=ts"
export * from "./uploadBraExcelModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__